module.exports = __webpack_public_path__ + "img/Konspiration.d221e84a.jpg";